import React from "react";
import Alram from "bodycodi/cmap/app/components/cmap6010/alram";

interface AlramList {
  alramList: any;
  scrollEnd: boolean;
  setRef: any;
  emptyPage: boolean;
}

function AlramList({ alramList, scrollEnd, setRef, emptyPage }: AlramList) {
  return (
    <>
      {emptyPage && <div className="message-pop-empty">새로운 알림 메세지가 없습니다.</div>}
      {!emptyPage && (
        <>
          {alramList.map((message: any) => (
            <Alram message={message} key={message.seqCoachAlarm} />
          ))}
          {!scrollEnd && <div ref={setRef}></div>}
        </>
      )}
    </>
  );
}

export default AlramList;
